import { videoService } from "../../services/api";
import { Video } from "../../types/video/video";

let videoList: Video[] = [
  {
    orderID: 1,
    imageLink: "/assets/videos/test1.jpg",
    redirectLink: "https://www.youtube.com/watch?v=h7C0bJixVAk",
    name: "Найголовніше – показати людям, що вони можуть кайфувати від служби – командир 210 ОШП",
    description: "Проєкт Укрінформу «Командири нашої перемоги»",
  },
  {
    orderID: 2,
    imageLink: "/assets/videos/test2.jpg",
    redirectLink: "https://www.youtube.com/watch?v=OsgqZqezNrw",
    name: "Правда про ПТСР та бойовий стрес –  військова психологиня 210 ОШП",
    description: undefined,
  },
  {
    orderID: 3,
    imageLink: "/assets/videos/test3.jpg",
    redirectLink: "https://www.youtube.com/watch?v=ld4Ze2iz4BU",
    name: "Ідеологія «руського міра» – це політична маніпуляція – військовий капелан 210 ОШП",
    description: undefined,
  },
  {
    orderID: 4,
    imageLink: "/assets/videos/test4.jpg",
    redirectLink: "https://www.youtube.com/watch?v=OVG-UuufSpc",
    name: "Топ порад для мобілізованих, як підготуватися до війни – інструктор 210 ОШП",
    description: undefined,
  },
];

export async function loadVideos() {
  try {
    // Call the API to get all video entries
    const response = await videoService.getAll();

    // Extract the data from the response
    const newVideoList: Video[] = response.data.map((video: any) => ({
      ...video,
      redirectLink: video.redirectlink ?? video.redirectLink,
    }));

    // Sort by orderID before returning
    if (newVideoList.length >= 4)
    videoList = newVideoList.sort((a, b) => a.orderID - b.orderID);
  } catch (error) {
    console.error("Failed to load videos:", error);
    throw new Error("Не вдалося завантажити відео");
  }
}

export function getVideos() {
  return structuredClone(videoList).sort((a, b) => a.orderID - b.orderID);
}
